import { PaymentMethod } from '../../constants';
function getFallbackPaymentTab(offers, validPaymentTabs) {
    const offersCount = { rebate: 0, lease: 0, finance: 0 };
    Object.values(offers).forEach(payment => {
        var _a, _b, _c;
        offersCount.rebate += ((_a = payment.cash) === null || _a === void 0 ? void 0 : _a.length) || 0;
        offersCount.lease += ((_b = payment.lease) === null || _b === void 0 ? void 0 : _b.length) || 0;
        offersCount.finance += ((_c = payment.finance) === null || _c === void 0 ? void 0 : _c.length) || 0;
    });
    return validPaymentTabs.find(tab => offersCount[tab] > 0) || validPaymentTabs[0] || PaymentMethod.lease;
}
export default getFallbackPaymentTab;
